import { Radio, RadioProps } from '@material-ui/core';
import React from 'react';

const PrimaryRadio = (props: RadioProps) => {
  return <Radio color="primary" {...props} />;
};
export default PrimaryRadio;
